module.exports = __webpack_public_path__ + "img/ranch-dressing.be7e38b6.jpg";